import React from 'react';
import { Accordion } from 'react-bootstrap';
import { dateRenderer } from '../../../../services/formatSvc';

import './Description.less';

const accordionContent = [
  { title: 'Цель', field: 'goal' },
  { title: 'Задачи', field: 'tasks' },
  { title: 'Ожидаемые результаты', field: 'result' },
  { title: 'Потребители результата', field: 'consumers' },
  { title: 'Описание', field: 'descr' },
  { title: 'Период реализации', render: (data) => `${dateRenderer(data.startDate)} - ${dateRenderer(data.endDate)}` },
];

const getAccordionItemClassName = (index, length) => {
  const flatBottomCorners = index === 0 || index < length - 1;
  const flatTopCorners = index > 0 || index === length - 1;

  return `${flatTopCorners ? 'flat-top-corners' : ''} ${flatBottomCorners ? 'flat-bottom-corners' : ''}`;
};

export default function PortfolioTabDescription({ data }) {
  return (
    <div className="tab-description">
      <section style={styledSection}>

        {accordionContent.map((item, index) => (
          <Accordion defaultActiveKey={0}>
            <Accordion.Item eventKey={0} key={index} className={getAccordionItemClassName(index, accordionContent.length)}>
              <Accordion.Header>{item.title}</Accordion.Header>
              <Accordion.Body>
                { !item.render ? (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: (data[item.field] || '').replace(/\n/gi, '<br>'),
                    }}
                  />
                ) : item.render(data)}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ))}
      </section>
    </div>
  );
}

const styledSection = { marginBottom: 32, color: 'initial' };
